/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Center, useMantineTheme, Loader, rem } from '@mantine/core';

export default function Loading() {
  const theme = useMantineTheme();

  return (
    <Center h="100%" mih={rem(300)}>
      <Loader color={theme.pf.color.fg.cloudblue.default.base} />
    </Center>
  );
}

Loader.displayName = 'Loader';
